import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MobileNumberModalComponent } from './mobile-number-modal.component';
import { PhoneInputModule } from '../../lib/phone-input/phone-input.module';
import { ButtonModule } from '@xref/xref-lib';
import { LoaderModule } from '../loader/loader.module';

@NgModule({
  declarations: [MobileNumberModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    PhoneInputModule,
    ButtonModule,
    LoaderModule
  ],
  exports: [MobileNumberModalComponent]
})
export class MobileNumberModalModule {
}


